import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AlertService } from "../../../alert/alert.service";
import {
  NavLink,
  NavRoleMapping,
  NavRoles,
} from "../../navigation.models";
import { NavigationService } from "../../navigation.service";
import { AppService } from "../../../../../app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-Rolemapping-dialog",
  templateUrl: "./Rolemapping-dialog.component.html",
  styleUrls: ["./Rolemapping-dialog.component.scss"],
})

export class RoleMappingDialogComponent implements OnInit {
  public form: FormGroup;
  roleMapping: any[] = [];
  searchFilter: any = {};
  public parent: any[];
  public common: any;
  subscription: Subscription;
  public DataMap: any;
  public data: any[] = [];
  public roles: any[] = [];
  public heading: boolean = true;
  public DataNavRoles: any[] = [];
  public data1: NavLink[] = [];
  public existingnavroles: NavRoleMapping[] = [];
  public existingnavlinks: any[] = [];
  public navdemo: any[] = [];
  public rolesflt: any;
  public parentflt: any;
  public childflt: any;
  public RoleListCtrl: FormControl = new FormControl();
  public LinkListCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  public datan: any[] = [];
  source: any;
  @Input() SavedRoles: boolean;
  @Output() submitRoles = new EventEmitter<any>();
  access = ['Create', 'Update', 'Delete']
  Source = [
    {
      id: "NONE",
      name: "NONE",
    },
    {
      id: "ERP",
      name: "ERP",
    },
    {
      id: "LCP",
      name: "LCP",
    },
  ];
  filterData: any[];
  allSelectedRoleData: any;
  sourceFiltered: any;
  constructor(
    public fb: FormBuilder,
    public alertServices: AlertService,
    public navservice: NavigationService,
    public commonService: AppService,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {

    this.subscription = this.navservice.rolesub$.subscribe((val) => {
      this.common = val;
      this.RoleListCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((val) => {
          this.roles = this.searchRoleList(val);
        });
      this.LinkListCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((val) => {
          this.data = this.searchLinkList(val);
        });
      if (this.common.Isdialog === false) {
        this.heading = false;
      }
    });
    this.navservice.allRole$.subscribe((val) => {
      this.allSelectedRoleData = val;
      console.log(this.allSelectedRoleData);
    });

    if (this.common) {
      this.GetAllNavLink();
    } else {
      if (this.common == undefined || this.common.NavLinkRoleId == null) {
        let a = new NavRoleMapping();
        this.common = a;
      }
    }
    if (this.common.source == " ERP") {
      this.source = "ERP";
      this.sourceFiltered = "erp";
    } else {
      this.source = "LCP";
      this.sourceFiltered = "lcp";
    }
    this.form = this.fb.group({
      roleId: [null, Validators.required],
    });
  }
  hierarchicalData: any
  ngOnInit() {
    this.GetAllRoles();
    this.GetAllNavRolesMap();
    if (this.common.navLinkRoleId != undefined) {
      this.form.get('roleId')?.disable();
    }
  }

  GetAllRoles() {
    this.navservice.listNavRolesData().subscribe((data) => {
      if (data) {
        this.roles = data as Array<NavRoles>;
        this.rolesflt = this.roles;
        this.roles = this.roles.map(ele => {
          ele.id = ele.id.toLowerCase();
          return ele;
        })
        if (this.common && this.common.roleId) {
          this.form.get("roleId")?.patchValue(this.common.roleId.toLowerCase());
        }
      }
    });
  }

  // change the Source data
  changeSource(event: any) {
    let filter = event.value.toLowerCase();
    this.sourceFiltered = filter;
    if (filter == "none") {
      this.data = this.filterData;
    } else {
      this.data = this.filterData.filter(
        (n) => n.source != null && n.source.toLowerCase().includes(filter)
      );
    }
  }


  getFinalData() {
    const navLinks = this.data;
    const navLinkRoles = this.DataNavRoles;
    this.data = navLinks.map(link => {
      const matchedRole = navLinkRoles.find(role => role.linkName === link.title);
      if (matchedRole) {
        return {
          ...link,
          access1: matchedRole.navigationAccess[0].access
        };
      }
      return link;
    });
  }
  closeDialog() {
    if (!this.common.Isdialog) {
      this.common.Isdialogclosed = true;
      this.navservice.sendRoleCloseDialog(this.common);
      this.data = [];
    }
  }
  onPermissionChange(event: Event, mile: any, permission: string): void {
    const checkbox = event.target as HTMLInputElement;
    if (!mile.access1) {
      mile.access1 = [];
    }
    if (checkbox.checked) {
      if (!mile.access1.includes(permission)) {
        mile.access1.push(permission);
      }
    } else {
      mile.access1 = mile.access1.filter((perm: string) => perm !== permission);
    }
  }

  onUserSubmit(values: Object): void {
    // if(this.form.valid){
    const user = new NavRoleMapping();
    Object.assign(user, this.form.getRawValue());

    user.NavigationAccess = this.common?.Navlinkmap || this.roleMapping;

    if (this.common?.navLinkRoleId) {
      user.NavLinkId = 0;
      user.NavLinkRoleId = this.common.navLinkRoleId;

      this.navservice.UpdateNavRole(user).subscribe({
        next: () => {
          this.closeDialog();
          this.submitRoles.emit();
          this.reloadComponent();
          this.alertServices.success("Record updated successfully.");
        },
        error: () => this.alertServices.error("Navigation Role update error."),
      });

    } else {
      if (!user.NavigationAccess || user.NavigationAccess.length === 0) {
        this.alertServices.error("Please select at least one checkbox.");
        return;
      }

      this.navservice.AddNavRole(user).subscribe({
        next: () => {
          this.closeDialog();
          this.submitRoles.emit();
          this.reloadComponent();
          this.alertServices.success("Record updated successfully.");
        },
        error: () => this.alertServices.error("Navigation Role save error."),
      });
    }

    // }
  }

  searchRoleList(value: string) {
    let filter = value.toLowerCase();
    this.parentflt = this.rolesflt;
    return this.parentflt.filter((n: any) => n.name.toLowerCase().includes(filter));
  }

  searchLinkList(value: string) {
    let filter = value.toLowerCase();
    if (this.sourceFiltered == "lcp") {
      let lcpData = this.DataMap.filter((item: any) => item.source == "LCP");
      this.childflt = lcpData;
      return this.childflt.filter((n: any) =>
        n.title.toLowerCase().includes(filter)
      );
    } else if (this.sourceFiltered == "erp") {
      let erpData = this.DataMap.filter((item: any) => item.source == "ERP");
      this.childflt = erpData;
      return this.childflt.filter((n: any) =>
        n.title.toLowerCase().includes(filter)
      );
    } else {
      return this.filterData.filter((n) =>
        n.title.toLowerCase().includes(filter)
      );
    }
  }

  onRoleChange(event: any) {
    if (event.data != "" && event.data != undefined && event.data != null) {
      let a = this.roles.filter((x) =>
        x.name.toLowerCase().includes(event.data.toLowerCase())
      );
      this.roles = a;
    } else {
      this.GetAllRoles();
    }
  }

  onLinkChange(event: any) {
    this.data1 = this.DataMap;
    if (event.data != "" && event.data != undefined && event.data != null) {
      let a = this.data.filter((x) =>
        x.title.toLowerCase().includes(event.data.toLowerCase())
      );
      this.data = a;
    } else {
      this.data = this.data1;
    }
  }

  GetAllNavRolesMap() {
    let obj ={}
      if(this.common.roleId){
        obj={roles: [this.common.roleId]}
      }else{
        obj={roles:null}
      }
  
    this.navservice.listNavMapRolesData(obj).subscribe((data) => {
      if (data) {
        this.DataNavRoles = data as Array<NavRoleMapping>;
        this.getFinalData()
      }
    });
  };

  checkbox: any
  parentselect(event: any) {
    if (event.source.selected && this.common.NavLinkRoleId == undefined) {
      let id = event.source.value
      this.commonService.get<any>(`api/Navigation/getAssignedModule/${id}`).subscribe(res => {
        this.checkbox = res
        this.GetAllNavLink();
      })
    } else {
      if (event.isUserInput) {
        console.log(this.allSelectedRoleData);
        let data: any = {};
        data.Navlinkmap = [];
        this.datan = this.allSelectedRoleData.filter(
          (x: any) =>
            x.roleId.toUpperCase() == event.source.value.toUpperCase() &&
            x.isDeleted == false
        );
        if (this.datan) {
          for (var a = 0; a < this.datan.length; a++) {
            data.Navlinkmap.push(this.datan[a].navLinkId);
          }
        }
        if (
          this.common.navLinkRoleId != undefined &&
          this.common.navLinkRoleId != null
        ) {
          data.navLinkRoleId = this.common.navLinkRoleId;
          data.Isdialog = false;
        }
        this.common = data;
        this.GetAllNavLink()
      }
    }

  }

  reloadComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['mapping']);
    });
  }

  isSaveDisabled(): boolean {
    return !this.data.some(item => item.isAdmin && item.orderNo);
  }

  GetAllNavLink() {
    let obj = {};
    this.navservice.listAllParentNavLinkData(obj).subscribe((data) => {
      if (data) {
        this.DataMap = data;
        this.data = this.DataMap;
        this.filterData = this.DataMap;

        const checkboxMap = new Map<number, { isDisabled: boolean; orderNo: number | null }>();
        if (this.checkbox && Array.isArray(this.checkbox)) {
          this.checkbox.forEach((item: any) => {
            checkboxMap.set(item.navLinkId, {
              isDisabled: item.isDisabled,
              orderNo: item.orderNo
            });
          });
        }

        this.data.forEach((item) => {
          const matched = this.common?.Navlinkmap?.find(
            (ele: any) => ele.navLinkId === item.navLinkId
          );
          if (matched) {
            item["isAdmin"] = true;
            item["orderNo"] = matched.orderNo ?? null;
          }

          const checkboxEntry = checkboxMap.get(item.navLinkId);
          if (this.common?.navLinkId === undefined && checkboxEntry) {
            item["isDisabled"] = checkboxEntry.isDisabled;
            item["orderNo"] = checkboxEntry.orderNo;

            // ✅ If orderNo is assigned, set isAdmin to false
            item["isAdmin"] = checkboxEntry.orderNo !== 0
              ? true
              : !item["isAdmin"];
          }
        });

        this.data1 = this.filterData;
        this.hierarchicalData = this.transformToHierarchy(this.data1);

        this.hierarchicalData.forEach((parent: any) => {
          if (Array.isArray(parent.children)) {
            parent.children.forEach((child: any) => {
              const checkboxEntry = checkboxMap.get(child.navLinkId);
              if (checkboxEntry) {
                child["orderNo"] = checkboxEntry.orderNo;
                child["isDisabled"] = checkboxEntry.isDisabled;
                child["isAdmin"] = checkboxEntry.orderNo !== 0
                  ? true
                  : !child["isAdmin"];
              }
            });
          }
        });
        // this.hierarchicalData.forEach((parent: any) => {
        //   if (Array.isArray(parent.children)) {
        //     parent.children.forEach((child: any) => {
        //       const checkboxEntry = checkboxMap.get(child.navLinkId);
        //       if (checkboxEntry) {
        //         child["orderNo"] = checkboxEntry.orderNo;
        //         child["isDisabled"] = checkboxEntry.isDisabled;

        //         // ✅ Apply same logic to children
        //         if (checkboxEntry.orderNo === 0 && checkboxEntry.orderNo !== undefined) {
        //           child["isAdmin"] = false;
        //         } else {
        //           child["isAdmin"] = true;
        //         }
        //       }
        //     });
        //   }
        // });
      }
    });
  }

  transformToHierarchy(data: any[]): any[] {
    const parentMap = new Map<string, any>();
    const usedChildIds = new Set<number>();
    const hasNavigationAccess = this.common?.navigationAccess !== undefined;

    const roleOrderMap = new Map<number, number | null>();
    if (Array.isArray(this.DataNavRoles)) {
      this.DataNavRoles.forEach((roleItem: any) => {
        roleOrderMap.set(roleItem.navLinkId, roleItem.linkOrder ?? null);
      });
    }

    // Step 1: Add parent items
    data.forEach(item => {
      if (!item.parentName) {
        const matchedOrder = item.isAdmin
          ? roleOrderMap.get(item.navLinkId)
          : null;

        const newItem = {
          ...item,
          orderNo: item.isAdmin
            ? matchedOrder !== undefined
              ? matchedOrder
              : item.linkOrder ?? null
            : null,
          navLinkId: item.navLinkId,
          isAdmin: hasNavigationAccess ? item.isAdmin : false,
          children: [],
        };

        parentMap.set(item.linkName || `__orphan__${item.navLinkId}`, newItem);
      }
    });

    // Step 2: Assign children
    data.forEach(item => {
      if (item.parentName) {
        const matchedOrder = item.isAdmin
          ? roleOrderMap.get(item.navLinkId)
          : null;

        const childItem = {
          ...item,
          orderNo: item.isAdmin
            ? matchedOrder !== undefined
              ? matchedOrder
              : item.linkOrder > 0
                ? item.linkOrder
                : null
            : null,
          navLinkId: item.navLinkId,
          isAdmin: hasNavigationAccess ? item.isAdmin : false,
        };

        const parent = parentMap.get(item.parentName);
        if (parent) {
          parent.children.push(childItem);
          usedChildIds.add(item.navLinkId);
        } else {
          const key = `__unknown__${item.parentName}`;
          if (!parentMap.has(key)) {
            const fallbackOrder = item.isAdmin
              ? roleOrderMap.get(item.navLinkParentId) ?? (item.orderNo > 0 ? item.orderNo : null)
              : null;

            parentMap.set(key, {
              linkName: item.parentName,
              navLinkId: item.navLinkParentId,
              orderNo: fallbackOrder,
              isAdmin: item.isAdmin,
              children: [],
            });
          }
          const unknownParent = parentMap.get(key);
          unknownParent.children.push(childItem);
          usedChildIds.add(item.navLinkId);
        }
      }
    });

    // Step 3: Add orphans
    data.forEach(item => {
      const isAlreadyUsed = usedChildIds.has(item.navLinkId);
      const isStandalone = !item.parentName && !parentMap.has(item.linkName || '');

      if (!isAlreadyUsed && isStandalone) {
        const matchedOrder = item.isAdmin
          ? roleOrderMap.get(item.navLinkId)
          : null;

        parentMap.set(`__orphan__${item.navLinkId}`, {
          ...item,
          orderNo: item.isAdmin
            ? matchedOrder !== undefined
              ? matchedOrder
              : item.linkOrder > 0
                ? item.linkOrder
                : null
            : null,
          navLinkId: item.navLinkId,
          isAdmin: item.orderNo === 0 || item.orderNo === undefined ? false : true,
          children: [],
        });
      }
    });

    // Step 4: Remove duplicate orphans if an unknown with same navLinkId exists
    const finalResult = Array.from(parentMap.entries()).filter(([key, value]) => {
      if (key.startsWith("__orphan__")) {
        // Check if any "__unknown__" entry has the same navLinkId
        return !Array.from(parentMap.entries()).some(
          ([k, v]) =>
            k.startsWith("__unknown__") && v.navLinkId === value.navLinkId
        );
      }
      return true;
    }).map(([_, value]) => value);

    return finalResult;
  }

  getChildOrder(event: any, updatedItem: any): void {
    if (!updatedItem || !Array.isArray(updatedItem.children)) return;

    const children = updatedItem.children;

    const targetChild = children.find((child: any) => child.navLinkId === event.navLinkId);
    if (targetChild) {
      const orderNo = Number(event.orderNo);

      if (isNaN(orderNo)) {
        targetChild.orderNo = null;
        targetChild.checked = false;
      } else {
        targetChild.orderNo = orderNo;
        targetChild.checked = orderNo > 0; // Optionally reflect if valid
      }
    }

    // Sort: valid orderNo > 0 come first, then orderNo === 0 or null
    children.sort((a: any, b: any) => {
      const aOrder = (a.orderNo && a.orderNo > 0) ? a.orderNo : Infinity;
      const bOrder = (b.orderNo && b.orderNo > 0) ? b.orderNo : Infinity;
      return aOrder - bOrder;
    });

    // Reassign orderNo only to those with > 0
    let orderCounter = 1;
    children.forEach((child: any) => {
      if (child.orderNo && child.orderNo > 0) {
        child.orderNo = orderCounter++;
      } else if (child.orderNo === 0 || child.orderNo === null) {
        child.orderNo = 0; // Keep it as 0 for clarity
      }
    });

    const parent = this.hierarchicalData.find(
      (item: any) => item.navLinkId === updatedItem.navLinkId
    );
    if (parent) {
      parent.children = [...children];
    }
  }
  getCheckedValue(event: any, value: any) {
    const targetArray = this.common?.Navlinkmap || this.roleMapping;
    const isChecked = event.target.checked;

    if (Array.isArray(value.children) && value.children) {
      // It's a parent
      const parentNavLinkId = value.navLinkId;
      const parentOrder = value.orderNo;

      const childrenArray = value.children
        .filter((child: any) =>
          child.parentName === value.linkName &&
          typeof child.linkOrder === 'number'
        )
        .map((child: any) => ({
          navlinkid: child.navLinkId,
          childOrder: child.orderNo
        }));

      const existingIndex = targetArray.findIndex(
        (item: any) => item.navlinkid === parentNavLinkId
      );

      const newParentEntry = {
        OrderNo: parentOrder,
        navlinkid: parentNavLinkId,
        child: childrenArray
      };

      if (isChecked) {
        if (existingIndex === -1) {
          targetArray.push(newParentEntry);
        } else {
          targetArray[existingIndex] = newParentEntry;
        }
      } else {
        // Remove ALL entries with matching navlinkid
        for (let i = targetArray.length - 1; i >= 0; i--) {
          if (targetArray[i].navlinkid === parentNavLinkId) {
            targetArray.splice(i, 1);
          }
        }
      }

    } else {
      // Individual link (not a parent)
      const navlinkid = value.navLinkId;

      if (value.isAdmin !== true) {
        // ✅ Remove ALL matching navlinkid entries before returning
        for (let i = targetArray.length - 1; i >= 0; i--) {
          if (targetArray[i].navlinkid === navlinkid) {
            targetArray.splice(i, 1);
          }
        }
        return;
      }

      const entry = {
        navlinkid,
        OrderNo: value.orderNo ?? null
      };

      const exists = targetArray.some((item: any) => item.navlinkid === navlinkid);

      if (isChecked && !exists) {
        targetArray.push(entry);
      } else if (!isChecked) {
        // ✅ Remove ALL entries with matching navlinkid
        for (let i = targetArray.length - 1; i >= 0; i--) {
          if (targetArray[i].navlinkid === navlinkid) {
            targetArray.splice(i, 1);
          }
        }
      }
    }
  }
  onOrderChange(child: any, updatedItem: any): void {
    const dataArray = this.hierarchicalData;
    const isParentUpdate = !updatedItem.navLinkParentId;

    for (const item of dataArray) {
      if (isParentUpdate && item.navLinkId === updatedItem.navLinkId && item.isAdmin) {
        item.orderNo = Number(updatedItem.orderNo ?? item.orderNo);
      }

      if (Array.isArray(item.children)) {
        for (const childItem of item.children) {
          if (childItem.navLinkId === updatedItem.navLinkId && childItem.isAdmin) {
            childItem.childOrder = Number(updatedItem.childOrder ?? updatedItem.orderNo);
          }
        }
      }
    }

    if (isParentUpdate) {
      const reorderableParents = dataArray
        .filter((item: any) => !item.navLinkParentId && item.isAdmin && item.orderNo !== 0 && item.orderNo !== null)
        .sort((a: any, b: any) => (a.orderNo ?? Infinity) - (b.orderNo ?? Infinity));

      reorderableParents.forEach((item: any, index: number) => {
        item.orderNo = index + 1;
      });
    }

    for (const item of dataArray) {
      if (Array.isArray(item.children) && item.children.length > 0) {
        const children = item.children.filter((child: any) => child.isAdmin);
        children.sort((a: any, b: any) => (a.childOrder ?? Infinity) - (b.childOrder ?? Infinity));
        children.forEach((child: any, index: number) => {
          child.childOrder = index + 1;
        });
      }
    }

    // if (Array.isArray(this.data)) {
    //   this.data.forEach((item: any) => {
    //     const updatedParent = dataArray.find((d: any) => d.navLinkId === item.navLinkId);
    //     if (updatedParent && item.isAdmin) {
    //       if (isParentUpdate) {
    //         item.orderNo = updatedParent.orderNo;
    //       }

    //       if (Array.isArray(item.children)) {
    //         item.children.forEach((child: any) => {
    //           if (child.isAdmin) {
    //             const updatedChild = updatedParent.children?.find((c: any) => c.navLinkId === child.navLinkId);
    //             if (updatedChild) {
    //               child.childOrder = updatedChild.childOrder;
    //             }
    //           }
    //         });
    //       }
    //     }
    //   });
    // }
  }

}
